module.exports = __webpack_public_path__ + "img/1_gold.7f4025d2.svg";